import { render, staticRenderFns } from "./Historical-questionnaire.vue?vue&type=template&id=8185d3fa&scoped=true"
import script from "./Historical-questionnaire.vue?vue&type=script&lang=js"
export * from "./Historical-questionnaire.vue?vue&type=script&lang=js"
import style0 from "./Historical-questionnaire.vue?vue&type=style&index=0&id=8185d3fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8185d3fa",
  null
  
)

export default component.exports